import React, { Component } from "react";
import { Formik, Form, Field } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import { Button } from "zina-dogi-react";
import AsyncSelect from "react-select/async";
import { utils } from "~/utils";
import { service as wbsService } from "~/wbs/redux";
import { QCModal } from "~/qc";

const initValues = (oet, run) => {
    const res = {
        sap_customer_name: "",
        sap_down_payment_contract_number: "",
        sap_top_wbs: "",
        quantity_contract_number: "",
        payment_terms_code: "",
        customer_payment_terms: "",
        incoterms: "",
        sales_order_billing_plan: "",
        incoterms_code: ""
    };
    if (oet) {
        let {
            sap_customer_name,
            sap_down_payment_contract_number,
            sap_top_wbs,
            quantity_contract_number,
            payment_terms_code,
            customer_payment_terms,
            incoterms,
            // sales_order_billing_plan,
            incoterms_code
        } = oet;
        let sales_order_billing_plan = noNull(run ? run.sales_order_billing_plan : null);
        sap_customer_name = noNull(sap_customer_name);
        sap_down_payment_contract_number = noNull(sap_down_payment_contract_number);
        sap_top_wbs = noNull(sap_top_wbs);
        quantity_contract_number = noNull(quantity_contract_number);
        payment_terms_code = noNull(payment_terms_code);
        customer_payment_terms = noNull(customer_payment_terms);
        incoterms = noNull(incoterms);
        incoterms_code = noNull(incoterms_code);
        // if (run) {
        //     sales_order_billing_plan = noNull(sales_order_billing_plan);
        // }
        return {
            sap_customer_name,
            sap_down_payment_contract_number,
            sap_top_wbs,
            quantity_contract_number,
            payment_terms_code,
            customer_payment_terms,
            incoterms,
            incoterms_code,
            sales_order_billing_plan
        };
    }

    return res;
};

const noNull = value => {
    return value ? value : "";
};

const loadOptions = val => {
    return wbsService.get_sap_top_wbs_autocomplete(val).then(resp => {
        if (resp.data && resp.data.results) {
            const res = resp.data.results.map(item => {
                return { value: item.wbs_element, label: item.wbs_element };
            });
            return res;
        }
    });
};

class FandCForm extends Component {
    constructor(props) {
        super(props);
        this.formik = React.createRef();
    }

    static header = (
        <nav className="navbar">
            <span className="navbar-brand h4">F&C</span>
        </nav>
    );

    onClick = () => {
        if (this.refs.qc_modal) {
            const qc_number = this.formik.current && this.formik.current.state.values.quantity_contract_number;
            this.refs.qc_modal.toggle(qc_number);
        }
    };

    handleSubmit = (
        fn,
        {
            sap_customer_name,
            sap_down_payment_contract_number,
            sap_top_wbs,
            quantity_contract_number,
            payment_terms_code,
            customer_payment_terms,
            incoterms,
            incoterms_code,
            sales_order_billing_plan
        },
        { setSubmitting }
    ) => {
        const run_status = this.props.status;

        let res = {
            sap_customer_name,
            sap_down_payment_contract_number,
            sap_top_wbs: sap_top_wbs ? sap_top_wbs.value : null,
            quantity_contract_number,
            payment_terms_code,
            customer_payment_terms,
            incoterms,
            sales_order_billing_plan,
            incoterms_code,
            form: "f&c",
            by: "fandc"
        };

        if (run_status === 1) {
            res = {
                sap_customer_name,
                form: "f&c",
                by: "project"
            };
        }
        fn(utils.clearObjectNulls(res));
        setSubmitting(false);
    };

    render() {
        let init_values = { ...initValues(this.props.oet, this.props.run) };
        if (init_values.sap_top_wbs) {
            init_values["sap_top_wbs"] = { value: init_values.sap_top_wbs, label: init_values.sap_top_wbs };
        }
        if (this.props.oet){
            init_values.sap_customer_name = parseInt(this.props.oet.stp_number)
        }
        return (
            <div>
                <div>
                    <QCModal ref="qc_modal" />
                </div>
                <div className="content">
                    <Formik
                        ref={this.formik}
                        initialValues={init_values}
                        enableReinitialize={true}
                        onSubmit={(values, cmp) => this.handleSubmit(this.props.onSubmit, values, cmp)}
                    >
                        {formik => (
                            <Form>
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <label>SAP Customer Name / Sold-to-party ID</label>
                                        <Field
                                            name="sap_customer_name"
                                            type="number"
                                            min={0}
                                            disabled={this.props.status !== 3 && (this.props.status !== 1 || this.props.oet.customer_purchase_order.customer_teams === 1)}
                                            className="form-control"
                                            value = {formik.values.sap_customer_name
                                                }
                                        />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <label>SAP Down Payment Contract Number</label>
                                        <Field
                                            name="sap_down_payment_contract_number"
                                            type="text"
                                            disabled={this.props.status !== 3}
                                            className="form-control"
                                        />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label>SAP Top WBS</label>
                                            <Field
                                                name="sap_top_wbs"
                                                component={AsyncSelect}
                                                disabled={this.props.status !== 3}
                                                isClearable
                                                cacheOptions
                                                defaultOptions
                                                isDisabled={this.props.status !== 3}
                                                value={formik.values.sap_top_wbs}
                                                loadOptions={loadOptions}
                                                onChange={val => formik.setFieldValue("sap_top_wbs", val, false)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label>Quantity Contract Number</label>
                                            <div className="row">
                                                <div
                                                    className={
                                                        formik.values.quantity_contract_number
                                                            ? "col-md-10"
                                                            : "col-md-12"
                                                    }
                                                >
                                                    <Field
                                                        name="quantity_contract_number"
                                                        type="number"
                                                        min={0}
                                                        className="form-control"
                                                        disabled={this.props.status !== 3}
                                                    />
                                                </div>
                                                {formik.values.quantity_contract_number && (
                                                    <div className="col-md-2">
                                                        <Button color="primary" type="button" onClick={this.onClick}>
                                                            <i className="fas fa-search-plus" />
                                                        </Button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label>Payment Terms Code</label>
                                            <Field
                                                name="payment_terms_code"
                                                type="text"
                                                className="form-control"
                                                disabled={this.props.status !== 3}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label>Customer Payment Terms</label>
                                            <Field
                                                name="customer_payment_terms"
                                                type="text"
                                                className="form-control"
                                                disabled={this.props.status !== 3}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label>Incoterm Code</label>
                                            <Field
                                                name="incoterms_code"
                                                type="text"
                                                className="form-control"
                                                disabled={this.props.status !== 3}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label>Incoterm Text</label>
                                            <Field
                                                name="incoterms"
                                                type="text"
                                                className="form-control"
                                                disabled={this.props.status !== 3}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label>Sales Order Billing Plan</label>
                                            <Field
                                                name="sales_order_billing_plan"
                                                type="text"
                                                className="form-control"
                                                disabled={this.props.status !== 3}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {(this.props.status === 3 || this.props.status === 1) && (
                                    <div className="row controls">
                                        <Button color="primary" type="submit">
                                            Save
                                        </Button>
                                    </div>
                                )}
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        );
    }
}

export default FandCForm;
